import React, {useEffect, useState} from 'react';
import {Breadcrumb, Card, Typography} from 'antd';
import {HomeOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import {authApi} from '../api/auth';
import {theme} from 'antd';

const {Title, Text} = Typography;

const Profile: React.FC = () => {
	const [userName, setUserName] = useState<string>('');
	const {
		token: {borderRadiusLG},
	} = theme.useToken();

	useEffect(() => {
		authApi.me().then(({data}) => {
			if (data?.name) setUserName(data.name);
		});
	}, []);

	return (
		<>
			<Breadcrumb
				style={{marginBottom: 16}}
				items={[
					{
						title: (
							<Link to="/">
								<HomeOutlined />
							</Link>
						),
					},
					{title: 'Профиль'},
				]}
			/>
			<Title level={4}>Профиль</Title>
			<Card style={{borderRadius: borderRadiusLG, maxWidth: 480}}>
				<Text>Пользователь: </Text>
				<Text strong>{userName || '…'}</Text>
			</Card>
		</>
	);
};

export default Profile;
